import { useState } from 'react';

const faqItems = [
  {
    id: 'faq1',
    question: 'Como funciona a primeira consulta?',
    answer: 'A primeira consulta é um momento dedicado a ouvir sua história. Realizamos uma avaliação completa do seu histórico de saúde, queixas atuais, hábitos de vida e objetivos. A partir disso, elaboramos uma investigação personalizada com exames específicos para o seu caso.',
  },
  {
    id: 'faq2',
    question: 'Quanto tempo dura o tratamento para emagrecimento?',
    answer: 'Cada organismo responde de forma única. O tempo de tratamento varia conforme seu metabolismo, adesão às orientações e objetivos individuais. Trabalhamos com metas progressivas e acompanhamento contínuo para resultados sustentáveis.',
  },
  {
    id: 'faq3',
    question: 'Vocês aceitam planos de saúde?',
    answer: 'Atendemos no formato particular. Isso nos permite dedicar o tempo necessário a cada consulta, sem as limitações impostas pelos convênios, garantindo uma avaliação verdadeiramente completa e individualizada.',
  },
  {
    id: 'faq4',
    question: 'A reposição hormonal é segura?',
    answer: 'Sim, quando indicada corretamente e acompanhada por um médico especializado. A reposição hormonal é sempre baseada em exames laboratoriais, avaliação clínica detalhada e monitoramento regular, respeitando as necessidades específicas de cada paciente.',
  },
  {
    id: 'faq5',
    question: 'O que é lipedema e como é tratado?',
    answer: 'O lipedema é uma condição crônica caracterizada pelo acúmulo anormal de gordura, principalmente nas pernas, frequentemente associado a dor e sensibilidade. O tratamento é individualizado e pode envolver mudanças alimentares, atividade física orientada, terapias específicas e acompanhamento médico regular.',
  },
  {
    id: 'faq6',
    question: 'Preciso de encaminhamento para agendar?',
    answer: 'Não é necessário encaminhamento. Você pode agendar sua consulta diretamente. Durante a avaliação, se identificarmos a necessidade de outros especialistas, faremos as orientações adequadas.',
  },
  {
    id: 'faq7',
    question: 'Como é feito o acompanhamento após a consulta?',
    answer: 'O acompanhamento é contínuo e personalizado. Dependendo do seu plano de tratamento, as consultas de retorno são agendadas em intervalos estratégicos para avaliar a evolução, ajustar condutas e garantir que você esteja no caminho certo para seus objetivos.',
  },
];

export default function FAQ() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundColor: '#0E1412' }}>
      <div
        className="absolute top-0 left-0 right-0 h-[1px]"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(200, 169, 106, 0.15) 50%, transparent 100%)' }}
      />

      <div className="max-w-[800px] mx-auto px-6 md:px-12">
        <div className="text-center mb-16 md:mb-20">
          <p
            className="text-sm tracking-[0.15em] mb-4"
            style={{
              fontFamily: 'var(--font-body)',
              color: '#C8A96A',
              fontWeight: 500,
            }}
          >
            FAQ
          </p>
          <h2
            className="text-3xl md:text-5xl"
            style={{
              fontFamily: 'var(--font-heading)',
              color: '#F8F7F5',
              fontWeight: 500,
              lineHeight: 1.2,
            }}
          >
            Dúvidas frequentes
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-[18px] overflow-hidden transition-all duration-400 cursor-pointer"
                style={{
                  backgroundColor: isOpen ? 'rgba(248, 247, 245, 0.03)' : 'rgba(248, 247, 245, 0.015)',
                  border: `1px solid ${isOpen ? 'rgba(200, 169, 106, 0.15)' : 'rgba(248, 247, 245, 0.06)'}`,
                }}
                onClick={() => toggle(item.id)}
              >
                <div className="flex items-center justify-between px-6 md:px-8 py-5 md:py-6">
                  <h4
                    className="text-sm md:text-base font-medium pr-4"
                    style={{
                      fontFamily: 'var(--font-body)',
                      color: isOpen ? '#C8A96A' : '#F8F7F5',
                      fontWeight: isOpen ? 600 : 500,
                      transition: 'color 0.4s',
                    }}
                  >
                    {item.question}
                  </h4>
                  <div
                    className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-all duration-400"
                    style={{
                      backgroundColor: isOpen ? 'rgba(200, 169, 106, 0.1)' : 'transparent',
                      transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                    }}
                  >
                    <i
                      className="ri-add-line text-lg"
                      style={{ color: isOpen ? '#C8A96A' : 'rgba(248, 247, 245, 0.3)' }}
                    />
                  </div>
                </div>
                <div
                  className="transition-all duration-400 ease-out overflow-hidden"
                  style={{
                    maxHeight: isOpen ? '300px' : '0px',
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <p
                    className="px-6 md:px-8 pb-5 md:pb-6 text-sm leading-relaxed"
                    style={{
                      fontFamily: 'var(--font-body)',
                      color: 'rgba(248, 247, 245, 0.5)',
                      fontWeight: 300,
                      lineHeight: 1.8,
                    }}
                  >
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}